import React, { Suspense, lazy } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { Loader } from "../UIKit";
import { routes } from "./routePaths";
import { usePageTracking } from "../analytics";
import { usePreserveVariation } from "../hooks/usePreserveVariation";
import "./AppRoutes.scss";

// Lazy load screens for better performance
const HomeScreen = lazy(() => import("../screens/HomeScreen/HomeScreen"));
const LoginScreen = lazy(() => import("../screens/LoginScreen/LoginScreen"));
const CreditGuardIframeSuccessScreen = lazy(
  () => import("../screens/CreditGuardIframeCallbacks/CreditGuardIframeSuccessScreen")
);
const CreditGuardIframeFailureScreen = lazy(
  () => import("../screens/CreditGuardIframeCallbacks/CreditGuardIframeFailureScreen")
);
const NotFoundScreen = lazy(() => import("../screens/NotFoundScreen/NotFoundScreen"));

/**
 * App Routes Component
 * Defines all routes in the application
 */
const AppRoutes: React.FC = () => {
    const location = useLocation();
    
    usePageTracking();
    usePreserveVariation();

    return (
        <>
        <img
            src="/absoluteCoins/header.png"
            alt=""
            className="app-coins-header"
            aria-hidden
        />
        <img
            src="/absoluteCoins/side.png"
            alt=""
            className="app-coins-side"
            aria-hidden
        />
        <Suspense
            fallback={
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
                    <Loader size="large" variant="spinner" />
                </div>
            }
        >
            <Routes location={location}>
                {/* Default route — travel-services hub */}
                <Route path="/" element={<Navigate to={routes.access} replace />} />

                <Route path={routes.access} element={<HomeScreen />} />

                {/* Flights (flight search) – same layout as hub, shows flight search card when authenticated */}
                <Route path={routes.flights} element={<HomeScreen />} />

                {/* Hotels and attractions – same layout as hub, shows hotels card + EligibleWebsites when authenticated */}
                <Route path={routes.hotelsAndAttractions} element={<HomeScreen />} />

                {/* Credit Guard iframe redirect targets (minimal pages; notify parent via postMessage) */}
                <Route
                    path={routes.creditGuardSuccess}
                    element={<CreditGuardIframeSuccessScreen />}
                />
                <Route
                    path={routes.creditGuardFailure}
                    element={<CreditGuardIframeFailureScreen />}
                />

                <Route path={routes.login} element={<LoginScreen />} />

                {/* 404 - Not Found */}
                <Route path="*" element={<NotFoundScreen />} />
            </Routes>
        </Suspense>
        </>
    );
};

export default AppRoutes;
